import React, { useState } from "react";
import { connect } from "react-redux";

import { selectAdequacy } from "store/user/adequacy/selectors";
import { setInvestmentStepData } from "store/user/investment/actions";
import { userDashboardDetailsSuccess } from "store/user/account/actions";
import { setAdequacyStart } from "store/user/adequacy/actions";

import Start from "./Start";
import UserData from "./UserData";
import MobileData from "./MobileData";
import { RenderAdequacyStep } from "components/AdequacyModal";
import TermsAndCondition from "./TermsAndCondition";
import WaitingForActivation from "./WaitingForActivation";
import Pending from "./Pending";
import Blocked from "./Blocked";
import Failed from "./Failed";
import NotRegistered from "./NotRegistered";
import Success from "./Success";
import MangopayScaVerification from "components/MangopayScaVerification";
import { paymentCreateBankingAlias, paymentCreateUser, paymentCreateWallets, paymentSubmitKYC } from "api";
import { useFormattedMessage } from "hooks";
import { sendFormError } from "i18n/messages/errors";
import { redirectToMangopaySCA } from "utils";
import { selectPlatformSourceFromApp } from "store/app/selectors";

const SecondaryMarketStep = ({
    setCloseTitle,
    step,
    setStep,
    isKycPending,
    isKycCompleted,
    isMobileValidated,
    isAdequacyCompleted,
    onCloseButtonClick,
    isAccepted,
    adequacyStep,
    setInvestmentStepData,
    setAdequacyStart,
    userDashboardDetailsSuccess,
    openEuroWallet,
    isPropertyDetail,
    mobileSuccess,
    open,
    backSlideEffect,
    setBackSlideEffect,
    isApp,
}) => {
    const { formatMessage } = useFormattedMessage();

    const [isMobileSucceed, setMobileSucceed] = useState(false);
    const [isMangopayScaButtonLoading, setMangopayScaButtonLoading] = useState(false);
    const [requestError, setRequestError] = useState(false);

    const renderStep = {
        start: (
            <Start
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setStep={setStep}
                isKycPending={isKycPending}
                isKycCompleted={isKycCompleted}
                isMobileValidated={isMobileValidated === true || isMobileSucceed === true ? true : false}
                isAdequacyCompleted={isAdequacyCompleted}
                onCloseButtonClick={onCloseButtonClick}
                openEuroWallet={openEuroWallet}
                open={open}
            />
        ),
        userData: (
            <UserData
                open={open}
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setStep={setStep}
                onCloseButtonClick={onCloseButtonClick}
            />
        ),
        mobileData: (
            <MobileData
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                setStep={setStep}
                mobileSuccess={() => {
                    mobileSuccess();
                    setMobileSucceed(true);
                }}
            />
        ),
        adequacyData: (
            <RenderAdequacyStep
                onAdequacyBack={() => {
                    setBackSlideEffect("step-slide-right");
                    setStep("start");
                }}
                isAccepted={isAccepted}
                step={adequacyStep}
                isWithSecondaryMarket
                kycCompleted={isKycCompleted}
                adequacyCompleted={isAdequacyCompleted}
                setInvestmentStepData={setInvestmentStepData}
                setAdequacyStart={setAdequacyStart}
                userDashboardDetailsSuccess={userDashboardDetailsSuccess}
                open={open}
            />
        ),
        termsAndCondition: (
            <TermsAndCondition
                open={open}
                setStep={setStep}
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
            />
        ),
        mangopayScaVerification: (
            <MangopayScaVerification
                overridePaddingClassName="py-8"
                backSlideEffect={backSlideEffect}
                isLoading={isMangopayScaButtonLoading}
                requestError={requestError}
                onButtonClick={() => {
                    try {
                        setMangopayScaButtonLoading(true);

                        const payload = {
                            IsFinexityTermsConditionsConfirmed: "true",
                            IsMangopayTermsConditionsConfirmed: "true",
                            IsUserSecondaryMarketPassDataConfirmed: "true",
                        };

                        paymentCreateUser(payload)
                            .then((res) => {
                                setMangopayScaButtonLoading(false);

                                if (!res || res.errors || res.data.errors || res.data.data.errors) {
                                    return setRequestError(formatMessage(sendFormError));
                                }

                                if (res?.data?.data?.paymentCreateUser?.redirectURL) {
                                    const redirectURL = res.data.data.paymentCreateUser.redirectURL;
                                    const returnURL = isApp ? "/account#accountEwallet" : "/dashboard#accountEwallet";

                                    redirectToMangopaySCA(redirectURL, returnURL, isApp);

                                    setTimeout(() => {
                                        paymentCreateWallets()
                                            .then((res) => {
                                                if (res?.data?.data?.paymentCreateWallets) {
                                                    setTimeout(() => {
                                                        paymentCreateBankingAlias()
                                                            .then((res) => {
                                                                if (res?.data?.data?.paymentCreateBankingAlias) {
                                                                    setTimeout(() => {
                                                                        paymentSubmitKYC().catch((err) => {
                                                                            console.log("paymentSubmitKYC err", err);
                                                                        });
                                                                    }, 500);
                                                                }
                                                            })
                                                            .catch((err) => {
                                                                console.log("paymentCreateBankingAlias err", err);
                                                            });
                                                    }, 500);
                                                }
                                            })
                                            .catch((err) => {
                                                console.log("paymentCreateWallets err", err);
                                            });
                                    }, 500);
                                }
                            })
                            .catch(() => {
                                setMangopayScaButtonLoading(false);
                            });
                    } catch (error) {
                        setMangopayScaButtonLoading(false);
                    }
                }}
            />
        ),
        waitingForActivation: (
            <WaitingForActivation
                backSlideEffect={backSlideEffect}
                isPropertyDetail={isPropertyDetail}
                onCloseButtonClick={onCloseButtonClick}
            />
        ),
        pending: <Pending onCloseButtonClick={onCloseButtonClick} />,
        blocked: <Blocked onCloseButtonClick={onCloseButtonClick} />,
        failed: <Failed onCloseButtonClick={onCloseButtonClick} />,
        notRegistered: <NotRegistered setCloseTitle={setCloseTitle} open={open} />,
        success: (
            <Success backSlideEffect={backSlideEffect} openEuroWallet={openEuroWallet} onCloseButtonClick={onCloseButtonClick} />
        ),
    };

    return renderStep[step] || <Start setStep={setStep} />;
};

const mapStateToProps = (state) => ({
    adequacyStep: selectAdequacy(state).step,
    isAccepted: selectAdequacy(state).isAccepted,
    isApp: selectPlatformSourceFromApp(state),
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    setAdequacyStart: (data) => dispatch(setAdequacyStart(data)),
    userDashboardDetailsSuccess: (data) => dispatch(userDashboardDetailsSuccess(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryMarketStep);
